// Định nghĩa các lỗi liên quan đến voucher
export const ERROR_VOUCHER = {
  VOUCHER_NOT_SUITABLE: 'errors.voucher_not_suitable',
  ONLY_APPLIED_FOR_RESTAURANTS: 'errors.voucher_just_apply_for_restaurants',
  HAVE_NOT_REACHED_MIN_ORDER_VALUE: 'errors.voucher_min_order_value',
  VOUCHER_NOT_FOUND: 'errors.voucher_not_found',
  VOUCHER_OUT_OF_STOCK: 'errors.voucher_out_of_quantity',
  VOUCHER_OUTSIDE_TIME_PERIOD: 'errors.voucher_outside_time_period',
  VOUCHER_USED: 'errors.voucher_has_been_used',
}

// Định nghĩa loại voucher
export const VOUCHER_TYPE = {
  PERCENT: 'percent',
  FIXED_DISCOUNT: 'fixed_discount',
}
